import { InputFieldRef } from '@/features/ui/inputs/components/InputField/types'
import React, { ForwardedRef, RefObject } from 'react'
import { TextInput } from 'react-native'

export const useImperativeHandle = (
    forwardedRef: ForwardedRef<InputFieldRef> = null,
    textInputRef: RefObject<TextInput | null>
): void => {
    React.useImperativeHandle(forwardedRef, () => ({
        focus: () => textInputRef.current?.focus(),
        blur: () => textInputRef.current?.blur(),
    }))
}
